import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import Switch from '@mui/material/Switch';
import Box from '@mui/material/Box';
import DEFAULT_SWITCH_CLASS_NAME from '../../theme/constants/switch';

const AvailableForFinancingSwitchFilter = ({ states, setStates }) => {
  const availableForFinancing = 'AVAILABLE';
  const isAvailableForFinancing = states.availableForFinancing === availableForFinancing;
  const handleOnChange = (event, value) => {
    if (!value) {
      setStates({
        ...states,
        availableForFinancing: null,
        preoffer_Preofferevaluationrequest_Isnull: null,
      });
    } else {
      setStates({
        ...states,
        availableForFinancing: 'AVAILABLE',
        preoffer_Preofferevaluationrequest_Isnull: true,
      });
    }
  };

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Switch
        className={DEFAULT_SWITCH_CLASS_NAME}
        onChange={handleOnChange}
        checked={isAvailableForFinancing}
      />
      <Typography variant="small_2">
        Mostrar solo financiables
      </Typography>
    </Box>
  );
};

AvailableForFinancingSwitchFilter.propTypes = {
  states: PropTypes.shape({
    availableForFinancing: PropTypes.string,
  }),
  setStates: PropTypes.func,
};

AvailableForFinancingSwitchFilter.defaultProps = {
  states: {},
  setStates: () => {},
};

export default AvailableForFinancingSwitchFilter;
